import '@vfde-brix/helpful/dist/styles.css';

import { createHelpfulComponent } from '@vfde-brix/helpful';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-helpful');

for (let i = 0, x = elements.length; i < x; i += 1) {

    // traversing one up to get the container element
    const containerElement = elements[i].parentNode as HTMLElement;

    createHelpfulComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
